/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CompassDeviceSource {
    ManufacturingLine = 'manufacturing_line',
    Backfill = 'backfill',
    UserScan = 'user_scan',
    AdminCorrection = 'admin_correction'
}


export function instanceOfCompassDeviceSource(value: any): boolean {
    for (const key in CompassDeviceSource) {
        if (Object.prototype.hasOwnProperty.call(CompassDeviceSource, key)) {
            if (CompassDeviceSource[key as keyof typeof CompassDeviceSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompassDeviceSourceFromJSON(json: any): CompassDeviceSource {
    return CompassDeviceSourceFromJSONTyped(json, false);
}

export function CompassDeviceSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompassDeviceSource {
    return json as CompassDeviceSource;
}

export function CompassDeviceSourceToJSON(value?: CompassDeviceSource | null): any {
    return value as any;
}

export function CompassDeviceSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): CompassDeviceSource {
    return value as CompassDeviceSource;
}

